import React from "react";
import classNames from "classnames";
import { IntegrationAccount } from "@common/types/integrationAccount";
import { IntegrationConnection } from "@common/types/integrationConnection";
import { useFinancialAccountEntitySelection } from "@hooks/useFinancialAccountEntitySelection";
import styles from "./AccountConnectionWidget/AccountsConnectionWidget.module.scss";
import { useFinancialAccountsConnectionContext } from "./FinancialAccountsConnectionContext";
import { isValidAccount } from "./helpers";
import { FinancialAccountConnectionRowV2 } from "./FinancialAccountConnectionRowV2";

interface AccountConnectionWidgetProps {
    accounts: IntegrationAccount[];
    integrationConnection?: IntegrationConnection;
}

export const FinancialAccountsConnectionWidgetV2: React.FC<
    AccountConnectionWidgetProps
> = ({ accounts, integrationConnection }) => {
    const { showBusinessEntitySelection } =
        useFinancialAccountEntitySelection();
    const entitySelection = showBusinessEntitySelection;
    const { showAccountTypeWarning } = useFinancialAccountsConnectionContext();
    const hasError =
        showAccountTypeWarning &&
        accounts.some(
            (a) => a.financialAccount && !isValidAccount(a.financialAccount),
        );

    return (
        <table
            className={classNames("table", styles.root, {
                [styles.error]: hasError,
            })}
        >
            <thead>
                {entitySelection && accounts.length > 0 && (
                    <tr
                        className={classNames(
                            "small",
                            "text-grey",
                            styles.headerLabels,
                        )}
                    >
                        <th>Account</th>
                        <th aria-label="Warning"></th>
                        <th>Entity</th>
                    </tr>
                )}
            </thead>

            <tbody>
                {accounts.length > 0 ? (
                    <>
                        {accounts.map(
                            (account) =>
                                account.financialAccount && (
                                    <FinancialAccountConnectionRowV2
                                        key={account.id}
                                        integrationAccount={account}
                                        financialAccount={
                                            account.financialAccount
                                        }
                                        integrationConnection={
                                            integrationConnection
                                        }
                                    />
                                ),
                        )}
                    </>
                ) : null}
            </tbody>
        </table>
    );
};
